import { Injectable } from '@angular/core';
import { CrudService } from '../../shared/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RewardService extends CrudService {

  merchantId;
  constructor(protected http: HttpClient) {
    super(http);
    this.setObject('reward');
  }

  update(data: any): Observable<any> {
    return this.http.post(this.apiUrl + this.object + '/' + data.id, data);
  }

  all(): Observable<any> {
    return this.http.get(this.apiUrl + this.object+'/list/' + this.merchantId);
  }

  upload(data: any): Observable<any> {
    return this.http.post(this.apiUrl + this.object + '/uploadImage', data);
  }
}